import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IOAuthConsentDecisionResponse,
  IOAuthConsentLoadResponse,
  IOAuthInteractionDetails,
  IOAuthOrganizationResponse,
} from '@shared/interfaces/oauth.interface';

import { OAuthApi } from './rest/oauth.api';

@Injectable({
  providedIn: 'root',
})
export class OAuthService {
  constructor(private oauthApi: OAuthApi) {}

  public getInteractionDetails(uid: string): Observable<IOAuthInteractionDetails> {
    return this.oauthApi.getInteractionDetails(uid);
  }

  public submitOrganization(uid: string, organization: string): Observable<IOAuthOrganizationResponse> {
    return this.oauthApi.submitOrganization(uid, organization);
  }

  public getConsent(requestId: string): Observable<IOAuthConsentLoadResponse> {
    return this.oauthApi.getConsent(requestId);
  }

  public decideConsent(requestId: string, approve: boolean): Observable<IOAuthConsentDecisionResponse> {
    return this.oauthApi.decideConsent(requestId, approve);
  }
}
